import { ValueFormatterParams } from 'ag-grid-community';
import { filter, flatten, get, isEmpty, isNil, map } from 'lodash';
import { Observable } from 'rxjs';

import { I18n } from '@app/i18n/strings-keys';
import {
  MajorReportingCategoryPath,
  MinorReportingCategoryPath,
} from '@app/shared/constants';

import { getGroupStrCaseInsensitiveComparator } from '../common/string-case-insensitive.comparator/string-case-insensitive.comparator';
import { CELL_FILTER } from '../types/enums/cell-filters.enum';
import { CELL_RENDERER } from '../types/enums/cell-renderer.enum';
import { ENTITY_TYPES } from '../types/enums/entityTypes.enum';
import { IXVIListColumn } from '../types/ui/xux-grid/xux-grid.type';
import { getLeafPropCollection } from './common-utils';

export const getProductColumns = <T = any>(params: {
  tagFilterValues?: T[] | Observable<T[]>;
}) =>
  <IXVIListColumn[]>[
    {
      path: MajorReportingCategoryPath,
      filterParams: {
        quickFilter: true,
      },
    },
    {
      path: MinorReportingCategoryPath,
      filterParams: {
        quickFilter: true,
      },
    },
    {
      title: I18n.EntityNames.Product,
      path: 'name',
      cellRenderer: CELL_RENDERER.ag_group_cell_renderer,
      cellRendererParams: {
        suppressCount: true,
      },
      defaultView: true,
      sortable: true,
      showRowGroup: true,
      filterParams: {
        quickFilter: true,
      },
      comparator: getGroupStrCaseInsensitiveComparator(),
      minWidth: 220,
    },
    {
      title: I18n.Forms.GridForm.ProductID,
      path: 'product_id',
      filterType: CELL_FILTER.string,
      cellRendererParams: {
        suppressCount: true,
      },
      defaultView: true,
      sortable: true,
      filterParams: {
        quickFilter: true,
        filterOptions: ['containsAny'],
      },
      comparator: getGroupStrCaseInsensitiveComparator(),
      minWidth: 220,
    },
    {
      title: I18n.EntityNames.Tags,
      // #TODO: need change to tag id
      path: 'product_tag_ids',
      filterType: CELL_FILTER.entity,
      defaultView: true,
      filterParams: {
        entity: ENTITY_TYPES.TAG,
        values: params.tagFilterValues,
        filterOptions: ['containsAny', 'containsAll', 'notContains'],
        suppressSelectAllControl: true,
        filterValueGetter: (data) => {
          const values = data.isLeaf
            ? [...get(data, 'tags', [])]
            : getLeafPropCollection(data.children, 'tags');

          const results = map(
            flatten(filter(values, (tag) => !isEmpty(tag))),
            'entity_id',
          );

          return results;
        },
      },
      valueFormatter: (formatterParams: ValueFormatterParams): string =>
        !isNil(formatterParams.data.tags)
          ? map(formatterParams.data.tags, 'name').join(', ')
          : '',
    },
  ];
